/**
 * External dependencies
 */
export default class ConnectionRetailerSalesTypes {
    constructor(id, cscom) {
        if (!(this instanceof ConnectionRetailerSalesTypes)) {
            return new ConnectionRetailerSalesTypes(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/user-connection-retailer-sales-types/${this.id}`;
        } else {
            this.path = `/user-site-api/user-connection-retailer-sales-types`;
        }
    }

    getConnectionRetailerSalesTypes() {
        return this.cscom.req.get(this.path);
    }
}
